import Axios from 'axios';
import AxiosMiddleware from '../libs/AxiosMiddleware';
import Config from '@/config';
import OPCODE from '@/libs/OPCODE';
import router from '../router';
import config from '../config';

export const TYPES = {
  MASTER_CHANGE_AUTH_STATUS: 'MASTER_CHANGE_AUTH_STATUS',
  MASTER_CHANGE_IS_LOADING: 'MASTER_CHANGE_IS_LOADING',
};

const state = {
  isLoading: false,
  isSignin: false,
};

const mutations = {
  [TYPES.MASTER_CHANGE_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
  [TYPES.MASTER_CHANGE_AUTH_STATUS](state, isSignin) {
    state.isSignin = isSignin;
  },
};

const actions = {
  async masterSignin({ commit, dispatch }, authInfo) {
    try {
      const {
        data,
      } = await Axios.post(
        `${Config.hostname}/v1/master/auth/signin`,
        authInfo,
        { withCredentials: true },
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            router.push('/master');
            commit(TYPES.MASTER_CHANGE_AUTH_STATUS, true);
            dispatch('masterRefreshMe');
            Config.alert.mixin({
              type: 'success',
              title: '성공적으로 로그인되었습니다.',
            });
            break;
        }
      }
    } catch {
      Config.alert.mixin({
        type: 'error',
        title: '인터넷 상태를 확인해주세요.',
      });
    }
  },
  async masterSignout({ commit }) {
    this._vm.$confirm({
      title: '로그아웃',
      content: '정말로 로그아웃하시겠습니까?',
      okText: '네, 로그아웃합니다.',
      okType: 'primary',
      cancelText: '아니요',
      onOk() {
        Axios.get(`${Config.hostname}/v1/master/auth/signout`, {
          withCredentials: true,
        });

        commit(TYPES.MASTER_CHANGE_AUTH_STATUS, false);
        router.push('/master/signin');
        clearInterval(window.refreshMe);
        clearInterval(window.refreshSaibs);
        clearInterval(window.refreshQuestion);
        clearInterval(window.refreshBroadcast);
        clearInterval(window.refreshWholesales);
        clearInterval(window.adminRefreshMe);
        clearInterval(window.uncleRefreshMe);
        clearInterval(window.unclePending);
        clearInterval(window.masterRefreshMe);
        Config.alert.mixin({
          type: 'success',
          title: '성공적으로 로그아웃되었습니다.',
        });
      },
    });
  },
  async masterRefreshMe({ commit }) {
    const { path } = router.currentRoute;

    if (path.startsWith('/master')) {
      try {
        commit(TYPES.MASTER_CHANGE_IS_LOADING, true);
        const { data } = await Axios.get(
          `${Config.hostname}/v1/master/auth/me`,
          {
            withCredentials: true,
          },
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              commit(TYPES.MASTER_CHANGE_AUTH_STATUS, true);
              if (router.history.current.path === '/master/signin') {
                router.push('/master');
              }
              break;
            default:
              router.push('/master/signin');
              config.alert.mixin({
                title: '오류로 인해 로그아웃되었습니다.',
                type: 'error',
              });
          }
        }
        commit(TYPES.MASTER_CHANGE_IS_LOADING, false);
      } catch (err) {
        commit(TYPES.MASTER_CHANGE_AUTH_STATUS, false);
        router.push('/master/signin');
        config.alert.mixin({
          title: '오류로 인해 로그아웃되었습니다.',
          type: 'error',
        });
      }
    }
  },
};

const getters = {};

export default { state, mutations, getters, actions };
